import { useState } from 'react';

import styles from './LoginGate.module.css';

interface LoginGateProps {
  onAuthorized: (keys: any) => void;
}

export function LoginGate({ onAuthorized }: LoginGateProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.SubmitEvent) => {
    e.preventDefault();
    if (isLoading) return;

    setError(false);
    setIsLoading(true);

    try {
      const response = await fetch('/unlock', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password })
      });

      if (response.ok) {
        const keys = await response.json();
        onAuthorized(keys);
      } else {
        setError(true);
        setPassword('');
      }
    } catch (err) {
      console.error("Fetch error:", err);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.wrapper}>
      <p className={styles.loginTip}>
        <strong>Indice:</strong> en minuscule, le nom de notre dernier chien suivi du code postal de Ke
      </p>
      <form className={styles.card} onSubmit={handleSubmit}>
        <div className={styles.inputWrapper}>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              if (error) setError(false);
            }}
            placeholder="Clé d'accès"
            disabled={isLoading}
            autoFocus
          />
          {error && <div className={styles.errorFloating}>Clé d'accès incorrecte</div>}
        </div>
      </form>
    </div>
  );
}